/**
 * Alpine.js Bundle - Self-hosted Alpine with plugins
 *
 * This bundles Alpine.js and required plugins locally,
 * eliminating CDN dependencies for offline-first support.
 */

import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';

// Register plugins
Alpine.plugin(focus);

// Expose globally (Alpine expects this)
window.Alpine = Alpine;

// Auto-start Alpine when DOM is ready
// (mimics the behavior of the CDN version)
document.addEventListener('DOMContentLoaded', () => {
  // Only start if not already started
  if (!Alpine.started) {
    Alpine.start();
  }
});

export default Alpine;
